import {
  differenceInSeconds,
  eachMinuteOfInterval,
  format,
  isBefore,
  parse
} from "date-fns";
import { AnestheticGas, FluidTemperature, Vital } from "requests";

export function getFormattedDate(hours: number, mins: number) {
  const date = new Date();
  date.setHours(hours, mins);
  return date;
}

export const generateTimeIntervals = (
  startTime: Date,
  endTime: Date,
  interval: number
) => {
  return eachMinuteOfInterval(
    {
      start: startTime,
      end: endTime
    },
    { step: interval }
  ).map(el => format(el, "h:mm a"));
};

export const getNearestTimeElement = (
  arr: Array<AnestheticGas | Vital | FluidTemperature>,
  currTime: Date
) => {
  const currTimestamp = currTime.getTime();
  let nearestTimestamp = 0;
  let nearestTime = "";

  arr.forEach(element => {
    const time = element.timeMonitoring;
    const timestamp = new Date(time).getTime();
    if (timestamp <= currTimestamp && timestamp > nearestTimestamp) {
      nearestTimestamp = timestamp;
      nearestTime = time;
    }
  });

  return arr.find(el => el.timeMonitoring === nearestTime) || null;
};

export const getNearestEarlyTimeElement = (timeStrings: string[]) => {
  const filteredTimes = timeStrings
    .map(timeString => parse(timeString, "h:mm a", new Date()))
    .filter(date => isBefore(date, new Date()));

  filteredTimes.sort((a, b) => b.getTime() - a.getTime());

  if (filteredTimes.length > 0) {
    return format(filteredTimes[0], "h:mm a");
  }
  return timeStrings[0];
};

export const getTimeDelta = (startTime: Date | null, endTime: Date | null) => {
  if (endTime && startTime) {
    return differenceInSeconds(
      new Date(endTime).setMilliseconds(0),
      new Date(startTime).setMilliseconds(0)
    );
  }

  if (!endTime && startTime) {
    return differenceInSeconds(
      new Date().setMilliseconds(0),
      new Date(startTime).setMilliseconds(0)
    );
  }

  return 0;
};

export const generateCaseTimeInterval = (curTime: Date, interval: number) => {
  const startTime = new Date(curTime ?? new Date());
  const startHours = startTime?.getHours();
  const startMinutes = startTime?.getMinutes();
  const startTimeInterval = getFormattedDate(startHours, startMinutes);
  const endTimeInterval = getFormattedDate(startHours + 8, startMinutes);

  return generateTimeIntervals(startTimeInterval, endTimeInterval, interval);
};
